
import {defineComponent} from "vue";
import {mapActions, mapState} from "pinia";
import {useAnalyticsStore} from "@/store/analytics.store";
import {useUIStore} from "@/store/ui.store";
import {usePlayerStore} from "@/store/player.store";

interface PostShareOverlayComponentInterface {
    linkCopied: boolean;
    showEmbedShare: boolean;
    embedCopied: boolean;
    isLarge: boolean;
}

export default defineComponent({
    name: "BaseShareOverlayComponent",
    props: {
        hideShareOverlay: { type: Function, required: true },
        isPostShare: { type: Boolean, required: true},
        showLink: { type: Boolean, required: false },
    },
    data(): PostShareOverlayComponentInterface {
        return {
            linkCopied: false,
            showEmbedShare: false,
            embedCopied: false,
            isLarge: true,
        }
    },
    methods: {
        // analytics
        ...mapActions(useAnalyticsStore, ['trackShareClick']),

        onCopyLink(): void {
            const copyText = this.$refs.shareUrl;
            if (copyText && copyText instanceof HTMLInputElement) {
                if (navigator.clipboard) {
                    navigator.clipboard.writeText(copyText.value);
                } else {
                    // fallback
                    copyText.select();
                    copyText.setSelectionRange(0, 99999); /*For mobile devices*/
                    document.execCommand('copy');
                }

                this.trackShareClick('copy');

                this.linkCopied = true;
                setTimeout(() => { this.linkCopied = false }, 3000);
            }
        },
        onEmbedClick(): void {
            this.trackShareClick("embed");
            this.showEmbedShare = true;
        },

        copyImmersive(): void {
            this.trackShareClick('copyEmbedImmersive');
            this.copyEmbedCode(this.$refs.immersiveCode);
        },
        copyMini(): void {
            this.trackShareClick('copyEmbedMini');
            this.copyEmbedCode(this.$refs.miniCode);
        },
        copyEmbedCode(textElement: HTMLInputElement | unknown): void {
            if (textElement && textElement instanceof HTMLInputElement) {
                if (navigator.clipboard) {
                    navigator.clipboard.writeText(textElement.value);
                } else {
                    // fallback
                    textElement.select();
                    textElement.setSelectionRange(0, 99999); /*For mobile devices*/
                    document.execCommand('copy');
                }

                this.embedCopied = true;
                setTimeout(() => { this.embedCopied = false }, 3000);
            }
        },
        /* eslint-disable */
        makeEmbedCode(isSmall: boolean): string {
          return `<script async
                    src="https://${process.env.VUE_APP_DOMAIN_NAME}/sdk/player.js"
                    data-mini="${isSmall}"
                    data-post-id="${this.postShareID}"><\/script>`;
        },
    },
    computed: {
        // analytics
        ...mapState(useAnalyticsStore, ["encodedPostURL"]),
        ...mapState(useAnalyticsStore, ["postShareURL"]),
        ...mapState(useAnalyticsStore, ["portalShareURL"]),
        ...mapState(useAnalyticsStore, ["shareVideoUrl"]),
        ...mapState(useAnalyticsStore, ["postShareID"]),
        // ui
        ...mapState(useUIStore, ["getHideLogo"]),
        // post
        ...mapState(usePlayerStore, {post: 'getActivePost'}),

        encodedShareURL(): string {
            return this.encodedPostURL;
        },
        shareURL(): string {
            return this.postShareURL;
        },
        immersiveCode(): string {
            return this.makeEmbedCode(false);
        },
        miniCode(): string {
            return this.makeEmbedCode(true);
        },
    }
});
